import React, { createContext, useContext } from "react";

interface DiagramContextValue {
  clientInitials?: string;
}

const DiagramContext = createContext<DiagramContextValue>({});

export function DiagramContextProvider({
  clientName,
  children,
}: {
  clientName?: string;
  children: React.ReactNode;
}) {
  const clientInitials = clientName
    ? clientName
        .split(/\s+/)
        .map((w) => w[0])
        .join("")
        .toUpperCase()
    : undefined;

  return (
    <DiagramContext.Provider value={{ clientInitials }}>
      {children}
    </DiagramContext.Provider>
  );
}

export function useDiagramContext() {
  return useContext(DiagramContext);
}
